import { useListContext } from 'react-admin'
import usePhysicalOrders from '../hooks/usePhysicalOrders'
import MenuButton from '@/components/MenuButton'
import DownloadIcon from '@mui/icons-material/Download'

const BulkDownloadCsv = () => {
  const { selectedIds } = useListContext()
  const { downloadBatchCsv } = usePhysicalOrders()

  const handleClick = (id: string) => {
    if (!selectedIds || selectedIds.length === 0) return

    downloadBatchCsv({
      batchIds: selectedIds,
      filters: {
        late: id === 'late',
        pending: id === 'opened',
        refunded: id === 'refunded'
      }
    })
  }

  return (
    <MenuButton
      label="Download CSV"
      onClick={handleClick}
      startIcon={<DownloadIcon />}
      dataTestId="bulk-download-csv-button"
      options={[
        { id: 'opened', name: 'Open Orders' },
        { id: 'all', name: 'All Orders' },
        { id: 'late', name: 'Late Orders' },
        { id: 'refunded', name: 'Refunded Orders' }
      ]}
    />
  )
}

export default BulkDownloadCsv
